
















































































































import { Vue, Component } from "vue-property-decorator"
import { getModule } from "vuex-module-decorators"
import { Server, Member, Invitation } from "@/store/server"
import InviteModal from "@/components/InviteModal.vue"

@Component({
  components: { InviteModal },
})
export default class Team extends Vue {
  members: Member[] = []
  invitations: Invitation[] = []
  isInviteModalActive = false

  async mounted() {
    await this.refresh()
  }

  async refresh() {
    try {
      this.members = await getModule(Server).getMyMembers()
      this.invitations = await getModule(Server).getMyInvitations()
    } catch (error) {
      this.$buefy.toast.open({ message: 'メンバー情報の取得に失敗しました。', type: 'is-danger' })
    }
  }

  async onInvited() {
    this.isInviteModalActive = false
    await this.refresh()
    this.$buefy.toast.open({ message: '招待メールを送信しました。', type: 'is-success' })
  }

  confirmDeleteMember(m: Member) {
    this.$buefy.dialog.confirm({
      message: `${m.email} を削除してよろしいですか？`,
      confirmText: '削除する',
      type: 'is-danger',
      onConfirm: async () => {
        try {
          await getModule(Server).deleteMyMember(m.account_id)
          await this.refresh()
          this.$buefy.toast.open({ message: 'メンバーを削除しました。', type: 'is-success' })
        } catch (error) {
          this.$buefy.toast.open({ message: 'メンバーの削除に失敗しました。', type: 'is-danger' })
        }
      },
    })
  }

  confirmRevokeInvitation(inv: Invitation) {
    this.$buefy.dialog.confirm({
      message: `${inv.email} 宛の招待を取消してよろしいですか？`,
      confirmText: '取消する',
      type: 'is-danger',
      onConfirm: async () => {
        try {
          await getModule(Server).deleteMyInvitation(inv.invitation_id)
          await this.refresh()
          this.$buefy.toast.open({ message: '招待を取消しました。', type: 'is-success' })
        } catch (error) {
          this.$buefy.toast.open({ message: '招待の取消に失敗しました。', type: 'is-danger' })
        }
      },
    })
  }

  roleLabel(role: string) {
    if (role === 'owner') return 'オーナー'
    if (role === 'member') return '管理者 (member)'
    if (role === 'viewer') return '閲覧専用'
    return role
  }

  statusLabel(status: string) {
    if (status === 'active') return '有効'
    if (status === 'suspended') return '凍結'
    if (status === 'deleted') return '削除済み'
    return status
  }

  invitationStatusLabel(status: string) {
    if (status === 'pending') return '未消費'
    if (status === 'consumed') return '消費済み'
    if (status === 'expired') return '失効'
    return status
  }

  statusTagType(status: string) {
    if (status === 'pending') return 'is-info'
    if (status === 'consumed') return 'is-success'
    if (status === 'expired') return 'is-light'
    return ''
  }

  formatTimestamp(ts: number) {
    return new Date(ts * 1000).toLocaleString('ja-JP')
  }
}
